import { render } from "./DmsLoading.vue?vue&type=template&id=5dbe8774&scoped=true&ts=true"
import script from "./DmsLoading.vue?vue&type=script&lang=ts"
export * from "./DmsLoading.vue?vue&type=script&lang=ts"

import "./DmsLoading.vue?vue&type=style&index=0&id=5dbe8774&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbe8774"]])

export default __exports__